// src/main.js
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { router } from './router.js';
import App from './App.vue';
import './styles/global.css';

const app = createApp(App);

// BP-JS-3: surface Vue-level errors instead of failing silently to a blank page.
app.config.errorHandler = (err, _instance, info) => {
  console.error('[Vue error]', info, err);
};

app.use(createPinia());
app.use(router);
app.mount('#app');
